var map = {
	"./afghanistan.png": "2f2f",
	"./aland-islands.png": "d029",
	"./albania.png": "fc88",
	"./algeria.png": "b402c",
	"./american-samoa.png": "9a97",
	"./andorra.png": "8351",
	"./angola.png": "1bbb",
	"./anguilla.png": "1dff",
	"./antarctica.png": "6ff5",
	"./antigua-barbuda.png": "3c5b",
	"./argentina.png": "2462",
	"./armenia.png": "bba7",
	"./aruba.png": "9f057",
	"./ascension-island.png": "113b",
	"./australia.png": "9517",
	"./austria.png": "e21f",
	"./azerbaijan.png": "8559",
	"./bahamas.png": "bb54",
	"./bahrain.png": "09a8",
	"./bangladesh.png": "0590",
	"./barbados.png": "5427",
	"./belarus.png": "b903",
	"./belgium.png": "3770",
	"./belize.png": "81b7",
	"./benin.png": "c32db",
	"./bermuda.png": "0203",
	"./bhutan.png": "15b0",
	"./black-flag.png": "0a74",
	"./bolivia.png": "c6ba",
	"./bosnia-herzegovina.png": "5cea",
	"./botswana.png": "0ebe",
	"./bouvet-island.png": "82ae6",
	"./brazil.png": "687fb",
	"./british-indian-ocean-territory.png": "06c4",
	"./british-virgin-islands.png": "abbd",
	"./brunei.png": "2aa38",
	"./bulgaria.png": "2d2f",
	"./burkina-faso.png": "1d94",
	"./burundi.png": "ebc0",
	"./cambodia.png": "9885",
	"./cameroon.png": "bf987",
	"./canada.png": "25e9",
	"./canary-islands.png": "96da",
	"./cape-verde.png": "3a2e",
	"./caribbean-netherlands.png": "ca72",
	"./cayman-islands.png": "39563",
	"./central-african-republic.png": "3b93",
	"./ceuta--melilla.png": "1f5c",
	"./chad.png": "42f8",
	"./chequered-flag.png": "b753",
	"./chile.png": "24f8",
	"./china.png": "b639",
	"./christmas-island.png": "bde1",
	"./clipperton-island.png": "d3ed",
	"./cocos-islands.png": "3d08",
	"./colombia.png": "a402",
	"./comoros.png": "0cbc",
	"./congo-brazzaville.png": "6d20",
	"./congo-kinshasa.png": "9e1d",
	"./cook-islands.png": "44c1",
	"./costa-rica.png": "c785",
	"./cote-divoire.png": "c26b",
	"./croatia.png": "1e70",
	"./crossed-flags.png": "5f40",
	"./cuba.png": "3395",
	"./curacao.png": "7302",
	"./cyprus.png": "701f3",
	"./czechia.png": "34e0",
	"./denmark.png": "8d10",
	"./diego-garcia.png": "f3fb",
	"./djibouti.png": "b349",
	"./dominica.png": "13f9",
	"./dominican-republic.png": "ed80",
	"./ecuador.png": "3016",
	"./egypt.png": "dde1",
	"./el-salvador.png": "2399",
	"./england.png": "d064",
	"./equatorial-guinea.png": "5fc3",
	"./eritrea.png": "63f8",
	"./estonia.png": "f59d",
	"./eswatini.png": "bb9d",
	"./ethiopia.png": "da78",
	"./european-union.png": "0f0f",
	"./falkland-islands.png": "4a67",
	"./faroe-islands.png": "0b10",
	"./fiji.png": "0716",
	"./finland.png": "8937",
	"./france.png": "5d38",
	"./french-guiana.png": "7b41a",
	"./french-polynesia.png": "028a",
	"./french-southern-territories.png": "bde7",
	"./gabon.png": "4cc5",
	"./gambia.png": "d712c",
	"./georgia.png": "ed4d9",
	"./germany.png": "9bea",
	"./ghana.png": "0e26",
	"./gibraltar.png": "18a9",
	"./greece.png": "3cb9",
	"./greenland.png": "e614",
	"./grenada.png": "860f",
	"./guadeloupe.png": "a0d1",
	"./guam.png": "c32c",
	"./guatemala.png": "6189",
	"./guernsey.png": "a2ee",
	"./guinea-bissau.png": "9c3b",
	"./guinea.png": "8d47",
	"./guyana.png": "151d",
	"./haiti.png": "e997",
	"./heard--mcdonald-islands.png": "a293",
	"./honduras.png": "c7714",
	"./hong-kong-sar-china.png": "ebd8",
	"./hungary.png": "4381",
	"./iceland.png": "2e4b",
	"./india.png": "6a1f",
	"./indonesia.png": "e08b",
	"./iran.png": "5856",
	"./iraq.png": "21e2",
	"./ireland.png": "c61f",
	"./isle-of-man.png": "dede",
	"./israel.png": "ef75",
	"./italy.png": "f929",
	"./jamaica.png": "4521",
	"./japan.png": "21c1",
	"./jersey.png": "2db3",
	"./jordan.png": "7662",
	"./kazakhstan.png": "970d",
	"./kenya.png": "72da",
	"./kiribati.png": "ae5d",
	"./kosovo.png": "d331e",
	"./kuwait.png": "aa44",
	"./kyrgyzstan.png": "7d11",
	"./laos.png": "77c3",
	"./latvia.png": "baac",
	"./lebanon.png": "9a1e",
	"./lesotho.png": "a62df",
	"./liberia.png": "ba6d",
	"./libya.png": "3948",
	"./liechtenstein.png": "fea1",
	"./lithuania.png": "f0bb7",
	"./luxembourg.png": "e643",
	"./macao-sar-china.png": "4e9e",
	"./madagascar.png": "035c",
	"./malawi.png": "6560",
	"./malaysia.png": "f5c9d",
	"./maldives.png": "06e5",
	"./mali.png": "fadc9",
	"./malta.png": "8f10",
	"./marshall-islands.png": "ac8f",
	"./martinique.png": "7682",
	"./mauritania.png": "ea7b",
	"./mauritius.png": "11ab",
	"./mayotte.png": "9695",
	"./mexico.png": "1efe",
	"./micronesia.png": "0f91",
	"./moldova.png": "b4268",
	"./monaco.png": "85cc",
	"./mongolia.png": "c09dd",
	"./montenegro.png": "5781",
	"./montserrat.png": "2fdd",
	"./morocco.png": "fe2a",
	"./mozambique.png": "f55a",
	"./myanmar-burma.png": "b9cf",
	"./namibia.png": "b660",
	"./nauru.png": "4b74",
	"./nepal.png": "a695",
	"./netherlands.png": "9437",
	"./new-caledonia.png": "5d1c",
	"./new-zealand.png": "224d",
	"./nicaragua.png": "090d8",
	"./niger.png": "ebe0",
	"./nigeria.png": "667a",
	"./niue.png": "9211",
	"./norfolk-island.png": "311f",
	"./north-korea.png": "7edb3",
	"./north-macedonia.png": "e5a4",
	"./northern-mariana-islands.png": "323d",
	"./norway.png": "4eb7",
	"./oman.png": "a006",
	"./pakistan.png": "bf79",
	"./palau.png": "44d1",
	"./palestinian-territories.png": "2924",
	"./panama.png": "29cb",
	"./papua-new-guinea.png": "4b105",
	"./paraguay.png": "b5042",
	"./peru.png": "d898",
	"./philippines.png": "edc1",
	"./pirate-flag.png": "15ab7",
	"./pitcairn-islands.png": "b78c",
	"./poland.png": "e203",
	"./portugal.png": "0074",
	"./puerto-rico.png": "d7d0",
	"./qatar.png": "be0d",
	"./rainbow-flag.png": "db510",
	"./reunion.png": "b12a",
	"./romania.png": "8956",
	"./russia.png": "6bf3",
	"./rwanda.png": "e940",
	"./saint-thomas-and-prince.png": "4ab1",
	"./saint-vincent-and-the-grenadines.png": "49e4",
	"./samoa.png": "bc59",
	"./san-marino.png": "4a3a",
	"./saudi-arabia.png": "267a",
	"./scotland.png": "89f5",
	"./senegal.png": "6e62",
	"./serbia.png": "c2e8",
	"./seychelles.png": "4c26",
	"./sierra-leone.png": "6ef4",
	"./singapore.png": "1b67",
	"./sint-maarten.png": "b4a5e",
	"./slovakia.png": "6c7e",
	"./slovenia.png": "0b94b",
	"./solomon-islands.png": "38ab3",
	"./somalia.png": "b803",
	"./south-africa.png": "ecb7",
	"./south-georgia--south-sandwich-islands.png": "24106",
	"./south-korea.png": "d0c51",
	"./south-sudan.png": "1a58",
	"./spain.png": "d0a8",
	"./sri-lanka.png": "d22f",
	"./st-barthelemy.png": "e684",
	"./st-helena.png": "609f",
	"./st-kitts-&-nevis.png": "b8d60",
	"./st-lucia.png": "4151",
	"./st-martin.png": "0362",
	"./st-pierre-miquelon.png": "dfe8",
	"./sudan.png": "6fe0",
	"./suriname.png": "a383",
	"./svalbard-jan-mayen.png": "dd68",
	"./sweden.png": "e328",
	"./switzerland.png": "5c68",
	"./syria.png": "d8a4",
	"./taiwan-china.png": "e4b9",
	"./tajikistan.png": "69d0",
	"./tanzania.png": "f391",
	"./thailand.png": "a5e1",
	"./timor-leste.png": "8871",
	"./togo.png": "685e",
	"./tokelau.png": "c8b5",
	"./tonga.png": "be73",
	"./transgender-flag.png": "1809",
	"./triangular-flag.png": "25f4",
	"./trinidad-tobago.png": "d882",
	"./tristan-da-cunha.png": "67d9",
	"./tunisia-circular.png": "228e",
	"./turkey.png": "d00dc",
	"./turkmenistan.png": "cb50",
	"./turks-caicos-islands.png": "9c42",
	"./tuvalu.png": "7e68",
	"./uganda.png": "3511",
	"./ukraine.png": "9b78",
	"./united-arab-emirates.png": "84cf1",
	"./united-kingdom.png": "ac1c",
	"./united-nations.png": "8c14",
	"./united-states-minor-outlying-islands.png": "1484",
	"./united-states-virgin-islands.png": "fee4",
	"./united-states.png": "4fbd8",
	"./uruguay.png": "f46e",
	"./uzbekistan.png": "016d",
	"./vanuatu.png": "5cbb",
	"./vatican-city.png": "18bc",
	"./venezuela.png": "11a4",
	"./vietnam.png": "bb61",
	"./wales.png": "b270",
	"./wallis-futuna.png": "552f",
	"./western-sahara.png": "a0dd",
	"./white-flag.png": "5fd55",
	"./yemen.png": "e56c",
	"./zambia.png": "3ef8",
	"./zimbabwe.png": "b011"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb45";